import { request } from './request';

import type { RequestProps } from './types';

export async function internalRequest<ResponseBody = unknown>({
  url,
  method,
  body,
  headers,
  abortController,
}: RequestProps): Promise<ResponseBody | null> {
  const requestHeaders = {
    ...headers,
  };

  const response = await request({
    url,
    method,
    body,
    headers: requestHeaders,
    abortController,
  });

  if (response) {
    return response.json();
  }

  return null;
}
